import { Location } from '../../../../core/clients/omni-core/models';

export type LocationCreateDialogFormModel = Location & {
  name: string;
  address: Location['address'] & {
    streetNumberSuffix: string;
  };
};

export const getEmptyLocationCreateDialogModel = (): LocationCreateDialogFormModel => ({
  name: '',
  address: {
    street: '',
    streetNumber: '',
    streetNumberSuffix: '',
    city: '',
    zipCode: '',
  },
});

export const toLocationPayload = (model: LocationCreateDialogFormModel) => ({
  name: model.name || undefined,
  description: model.description || undefined,
  address: {
    street: model.address.street,
    streetNumber: model.address.streetNumber,
    streetNumberSuffix: model.address.streetNumberSuffix || undefined,
    city: model.address.city,
    zipCode: model.address.zipCode,
  },
});
